﻿/* 
Object:         Tabguard
Description:    This ensures that there is only one tab active for the session. If another tab opens the existing tab will be redirected to the login page.
Used in:        Web Application main (global)
*/

/**
* Set listener
*/
if (window.addEventListener) {
    window.addEventListener("storage", storageHandler, false);
} else {
    window.attachEvent("onstorage", storageHandler);
}

/**
* If the browser tab guard value changed in a different tab redirect to login page
* @param {any} event
*/
function storageHandler(e) {
    // Do not refresh the current login page and begin a infinite loop against two or more tabs
    if (!e.url.includes("Login"))
    {
        if (e.key === "tabGuard" && window.name !== e.newValue) {
            window.location = window.origin + "?tabguard=true";
        }
    }
}


/**
* on document load
*/
$(function () {
    var time = new Date().getTime();
    window.name = time;
    localStorage.setItem('tabGuard', time);
});